// Uploads: Active Storage direct uploads with previews (FileUploadField, FileUploadSection).
import * as ActiveStorage from '@rails/activestorage'
import AttachedFilesController from './controllers/attached_files_controller'
import ImagePreviewController from './controllers/image_preview_controller'

ActiveStorage.start()

export function register(application) {
  application.register('attached-files', AttachedFilesController)
  application.register('image-preview', ImagePreviewController)
}
